

const NutritionGoals = ({nutrition})=>{
	const goalMacros = ['calorie','protein','carb','fat','water','sodium','fiber']
	const getGoalString = (macro)=>{
		const goalKey = `${macro}_goal`
		const goal = nutrition[goalKey]
		const macroDisplayText = macro === 'calorie' ? 'calories' : macro
		return Boolean(goal) ? `${goal} ${macroDisplayText}`:''
	}
	const hasGoal = ()=>{
		for (var i = goalMacros.length - 1; i >= 0; i--) {
			const goalKey = `${goalMacros[i]}_goal`
			if(Boolean(nutrition[goalKey])) return true
		}
		return false
	}
	if(!hasGoal()) return null
	return (
		<div style={{color:'black'}}>
			<strong>Macro Goals</strong>: {goalMacros.map(getGoalString).filter(s=>Boolean(s)).join(' | ')}
		</div>
	)
}

export default NutritionGoals